<div class="body">
    @if (data.reload_page) {
        <p>{{ 'refreshModal.reloadSuccess' | translate }}</p>
        <div class="countdown">{{ count }}</div>
    } @else {
        <p>{{ 'refreshModal.choosePeriod' | translate }}</p>
        <p-select
            appendTo="body"
            class="devise"
            [placeholder]="'refreshModal.periodPlaceholder' | translate"
            [ngModel]="period()"
            (ngModelChange)="period.set($event)"
            [options]="periodOptions"
            optionLabel="label"
            optionValue="value"
            fluid
        />
        @if (isCustomRange()) {
            <p-datepicker
                appendTo="body"
                selectionMode="range"
                [readonlyInput]="true"
                [showButtonBar]="false"
                [minDate]="minDate"
                [maxDate]="maxDate()"
                [ngModel]="range()"
                (ngModelChange)="range.set($event)"
                [placeholder]="'refreshModal.rangePlaceholder' | translate"
                fluid
            />
            <p-message severity="info" size="small" [text]="'refreshModal.rangeInfo' | translate" />
        }
    }
</div>

@if (!data.reload_page) {
    <div class="footer">
        <p-button rounded severity="secondary" [label]="'actionModal.cancelButton' | translate" (onClick)="close()" />
        <p-button rounded [label]="'actionModal.confirmButton' | translate" [disabled]="!canConfirm()" (onClick)="confirmRefresh()" />
    </div>
}
